/** Fired when local records pending upload may have changed (save, sync, cleanup). */
export const SHELL_PENDING_SYNC_COUNT_CHANGED_EVENT = 'shell:pending-sync-count-changed' as const;

/** Notifies shell chrome (nav badge) to re-read pending upload counts. */
export function dispatchShellPendingSyncCountChanged(): void {
  globalThis.dispatchEvent(new CustomEvent(SHELL_PENDING_SYNC_COUNT_CHANGED_EVENT));
}
